import React from 'react';
import Eye from 'lucide-react/dist/esm/icons/eye';
import X from 'lucide-react/dist/esm/icons/x';
import { useImpersonationStore } from '../../../stores';
import { Button } from '../../../components/ui';

const ImpersonationBanner: React.FC = () => {
  const { active, targetDisplayName, targetEmail, targetOrgName, stopImpersonation } =
    useImpersonationStore();

  if (!active) return null;

  const label = targetDisplayName || targetEmail || 'another user';

  return (
    <div className="flex items-center justify-center gap-3 px-4 py-1.5 bg-gradient-to-r from-rose-600/90 to-pink-600/90 text-white text-xs font-medium z-sticky relative shrink-0">
      <Eye size={14} className="shrink-0" />
      <span>
        Viewing as <strong>{label}</strong>
        {targetOrgName && (
          <span className="opacity-80"> ({targetOrgName})</span>
        )}
      </span>
      <Button
        variant="ghost"
        size="sm"
        onClick={stopImpersonation}
        className="!text-white !bg-white/15 hover:!bg-white/25 !py-0.5 !px-2 !text-xs !h-auto !min-h-0 ml-1"
      >
        <X size={12} className="mr-1" />
        Stop
      </Button>
    </div>
  );
};

export default React.memo(ImpersonationBanner);
